import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Nav from "../components/Nav"
import Main from "../components/Main"
import Footer from "../components/Footer"
import Services from "../components/Services"
import Contact from "../components/Contact"
import About from "../components/About"
import * as ROUTES from "../constants/routes"

import Landing from "../components/Landing"

function App() {
  return (
    <Router>
      <div className="App">
        <Nav />

        <Routes>
          <Route path={ROUTES.LANDING} element={<Landing />} />
          <Route path={ROUTES.SERVICES} element={<Services />} />
          <Route path={ROUTES.ABOUT} element={<About />} />
          <Route path={ROUTES.CONTACT} element={<Contact />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
